import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'
import moment from 'moment'
import { isEmpty, noop } from 'lodash'
import { useTranslation } from 'react-i18next'
import { ChevronRight32, Warning24 } from '@carbon/icons-react'

import Avatar from '@ublique/components/Avatar'
import ProgressBar from '@ublique/components/ProgressBar'
import useDateTimeFormat from 'utils/hooks/useDateTimeFormat'

const CLASS = 'notification-block'

const NotificationBlock = ({
  timestamp,
  title,
  message,
  read,
  type,
  cta,
  readAction,
  progress,
  avatarText,
  tParams,
  closePanel
}) => {
  const { t: notificationPanelT } = useTranslation([
    'NotificationPanelPlatform',
    'NotificationPanel'
  ])
  const { t, i18n } = useTranslation()

  const { dateTimeFormat } = useDateTimeFormat()

  const split = !isEmpty(avatarText) && avatarText.split('.')

  const textAvatar = isEmpty(avatarText)
    ? ''
    : split.length > 1
    ? split[0].toUpperCase().charAt(0) + split[1].toUpperCase().charAt(0)
    : split[0].toUpperCase().charAt(0)

  const status = title ? title?.split('_')[1] : ''

  const titleMsg = useMemo(() => {
    const splittedTitle = title?.split(':')
    const text = splittedTitle?.length > 1 ? splittedTitle[1] : splittedTitle[0]
    return i18n?.exists(title) ? t(title) : notificationPanelT(text)
  }, [title, t, notificationPanelT])

  const msg = useMemo(() => {
    const splittedTitle = message?.split(':')
    const text = splittedTitle?.length > 1 ? splittedTitle[1] : splittedTitle[0]
    return i18n?.exists(message)
      ? t(message, tParams)
      : notificationPanelT(text, tParams)
  }, [message, t, notificationPanelT])

  return (
    <div className={cn(`${CLASS}`, { unread: !read })} onClick={readAction}>
      {avatarText && (
        <div className={`${CLASS}__avatar ${type}`}>
          <Avatar text={textAvatar} type={type} />
        </div>
      )}
      <div className={`${CLASS}__left`}>
        <div className='d-flex-center'>
          {status === 'ERROR' ? <Warning24 /> : null}

          {title && <p className={`${CLASS}__title`}>{titleMsg}</p>}
        </div>

        {message && <p className={`${CLASS}__message`}>{msg}</p>}

        <p className={`${CLASS}__time`}>
          {moment(timestamp).format(dateTimeFormat.value)}
        </p>
        {!isNaN(progress) && progress !== 100 && (
          <div className={`${CLASS}__progress`}>
            <ProgressBar value={progress} />
          </div>
        )}
      </div>

      {cta && (
        <div className={`${CLASS}__right`}>
          <ChevronRight32
            onClick={() => {
              closePanel()
              cta()
            }}
          />
        </div>
      )}
    </div>
  )
}

NotificationBlock.propTypes = {
  userName: PropTypes.string,
  timestamp: PropTypes.number,
  title: PropTypes.string,
  message: PropTypes.string,
  read: PropTypes.bool,
  cta: PropTypes.func,
  readAction: PropTypes.func,
  progress: PropTypes.number,
  type: PropTypes.string,
  tParams: {}
}

NotificationBlock.defaultProps = {
  userName: 'user',
  timestamp: moment().local().valueOf(),
  readAction: noop,
  progress: NaN,
  read: true,
  type: '',
  tParams: {}
}

export default NotificationBlock
